import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_115_parts_return: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "121",
      action: "modulev1/parts_return",
    },
    title: "Parts return",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "return_no",
            Name: "parts_return_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/parts_return/<id>",
                },
                ActionType: "Edit",
                ScreenId: "121",
              },
            ],
            Form: {
              Name: "parts_return_summary",
              TableName: "service_spare_part_return",
              DisplayName: "Parts return",
              Query:
                "SELECT return_no, return_date, spare_issue_no FROM service_spare_part_return LEFT JOIN service_spare_part_issue ON service_spare_part_issue.id = service_spare_part_return.issue_id",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "Return No.",
                  BindValue: "txt_est",
                  Json_Attribute: "return_no",
                  componentType: ComponentType.TEXT_FIELD,
                  AutoPopulate: true,
                  AutoPopulate_format: "PRN_[******]",
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Issue No.",
                  BindValue: "txt_issue",
                  Json_Attribute: "spare_issue_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Return date",
                  BindValue: "txt_returndate",
                  Json_Attribute: "return_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: false,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
